import classNames from "classnames";
import Env from "../../environments";
import { Search } from "../../models/Search";
import { apiSearchAutoComplete } from "../../utils/api";
import { addHighlightText } from "../../utils/string";
import { DComponent } from "../DComponent";
import { replaceScript } from "../../utils/url";
import AvailableStore from "../AvailableStore";
import { DEFAULT_PER_PAGE_SEARCH_BAR_STORES } from "../../utils/constant";
import { isMobile, lockScroll } from "../../utils/utils";

const DEFAULT_PER_PAGE_AUTOCOMPLETE = 10;

export default class SearchForm extends DComponent {
  constructor({
    parent,
    id,
    defaultLoading,
    onInput = (value) => { },
    onChange = (value) => { },
    onSearch,
    hidePrefix = false,
    hideButton = false,
    noCheckValue = true,
    prefixImage,
    placeholderText,
    placeholderI18n,
    buttonText,
    buttonI18n,
    defaultValue = "",
    autoComplete = false,
    onAutoComplete,
    onFocus = () => { },
    onBlur = () => { },
    onClear = () => { },
    darkMode = false,
    showEmptyStores = false,
    callEmptyStoresApi = false,
  } = {}) {
    super(arguments[0], parent, id, {
      class: classNames("SearchForm", {
        "hide-prefix": hidePrefix,
        "hide-button": hideButton,
        "auto-complete": autoComplete,
        "dark-mode": darkMode
      }),
    }, true, defaultLoading);
    this.onInput = onInput;
    this.onChange = onChange;
    this.onSearch = onSearch;
    this.hidePrefix = hidePrefix;
    this.prefixImage = prefixImage;
    this.placeholderText = placeholderText;
    this.placeholderI18n = placeholderI18n;
    this.buttonText = buttonText;
    this.buttonI18n = buttonI18n;
    this.hideButton = hideButton;
    this.noCheckValue = noCheckValue;
    this.defaultValue = defaultValue;
    this.autoComplete = autoComplete;
    this.onAutoComplete = onAutoComplete;
    this.onFocus = onFocus;
    this.onBlur = onBlur;
    this.onClear = onClear;
    this.showEmptyStores = showEmptyStores;
    this.callEmptyStoresApi = callEmptyStoresApi;
    this.render();
  }

  loadStyle() {
    const style = require("!!css-loader!resolve-url-loader!sass-loader!./style.scss").toString();
    this.appendStyle(style, "SearchForm");
  }

  loadHtml() {
    return require("html-loader!./index.html");
  }

  after() {
    if (this.placeholderI18n) {
      $("input", this.element).attr("data-i18n", `[placeholder]${this.placeholderI18n}`);
    }
    if (this.placeholderText) {
      $("input", this.element).attr("placeholder", this.placeholderText);
    }
    if (this.prefixImage) {
      $(".prefix", this.element).attr("src", this.prefixImage);
    }
    if (this.buttonText) {
      $("button", this.element).html(this.buttonText);
    }
    if (this.buttonI18n) {
      $("button", this.element).attr("data-i18n", this.buttonI18n);
    }
    if (this.defaultValue) {
      $("input", this.element).val(this.defaultValue);
      this.checkValue();
    }

    $('input', this.element).focus((e) => {
      typeof this.onFocus == "function" && this.onFocus();
      this.element.addClass('focus');
      if (this.autoComplete) {
        $(e.currentTarget).autocomplete("search");
      }
      if (isMobile()) {
        lockScroll(true);
      }
    });

    if (this.showEmptyStores) {
      this.availableStore = new AvailableStore({
        parent: ".SearchForm .stores-box .container .border-box",
        perPage: DEFAULT_PER_PAGE_SEARCH_BAR_STORES,
        noSlider: true,
        isCallApi: this.callEmptyStoresApi,
      });
    }

    $(document).on('click', (e) => {
      if (!this.isFocus()) {
        return;
      }
      if ($(e.target).closest(`#${this.id}`).length === 0 || $(e.target).closest(`#${this.id} .dc-autocomplete-box`).length !== 0 || $(e.target).closest(`#${this.id} .stores-box`).length !== 0) {
        this.blur();
      }
    });

    $("input", this.element).on("input", () => {
      this.checkValue();
      typeof this.onInput == "function" && this.onInput(this.getValue());
    });

    $("input", this.element).on("change", () => {
      typeof this.onChange == "function" && this.onChange(this.getValue());
      if (this.getValue()) $('input', this.element).blur();
    });

    $("input", this.element).on("keydown", (e) => {
      if (e.key === 'Enter' || e.keyCode === 13) {
        this.search(this.getValue());
      }
    });

    $(".prefix", this.element).on("click", () => {
      this.isFocus() ? this.search(this.getValue()) : this.focus();
    });

    $(".btn-search", this.element).on("click", () => {
      this.search(this.getValue());
    });

    $(".clear", this.element).on("touchend click", (e) => {
      e.preventDefault();
      this.setValue("", true);
      if (this.autoComplete) {
        $(".dc-autocomplete-box", this.element).html("");
      }
      typeof this.onClear == "function" && this.onClear(this.getValue(), Search.SOURCE.SEARCH_INPUT);
      this.focus();
    });

    if (this.autoComplete) {
      this.autoCompleteSearch();
    }
  }

  search(keyword, type = Search.SOURCE.SEARCH_INPUT) {
    this.blur();
    if (typeof this.onSearch == "function") {
      this.onSearch(keyword, type);
    } else {
      Search.getRedirectSearch(keyword, true, type);
    }
  }

  getValue() {
    return replaceScript(($("input", this.element).val() || "")).trim();
  }

  setValue(value, trigger = false) {
    $("input", this.element).val(value);
    this.checkValue();
    trigger && $("input", this.element).trigger("change");
  }

  checkValue() {
    if (!this.noCheckValue) {
      if (this.getValue()) {
        if (!this.element.hasClass("has-value")) {
          this.element.addClass("has-value");
        }
        return true;
      } else {
        this.element.removeClass("has-value");
        return false;
      }
    }
  }

  autoCompleteSearch() {
    $('#search_input', this.element).autocomplete({
      delay: 300,
      appendTo: this.element,
      classes: {
        "ui-autocomplete": "dc-autocomplete-box"
      },
      source: async (request, response) => {
        let data = await this.eventAutoComplete();
        response(data);
        addHighlightText($(".dc-autocomplete-box .ui-menu-item", this.element), this.getValue());
      },
      select: (event, ui) => {
        if (typeof this.onAutoComplete == "function") {
          this.onAutoComplete(ui?.item?.value, Search.SOURCE.AUTOCOMPLETE);
        } else {
          this.search(ui?.item?.value, Search.SOURCE.AUTOCOMPLETE);
        }
      }
    })
  }

  async eventAutoComplete() {
    let data = await this.getAutoComplete(this.genParamsAutoComplete());
    return data;
  }

  getAutoComplete = (params) => {
    return new Promise((resolve, reject) => {
      apiSearchAutoComplete({ ...params, dc_source: Search.SOURCE.SEARCH_INPUT }, (data) => {
        const result = data?.data?.length ? data.data.slice(0, 10) : [];
        resolve(result);
      }, (_) => {
        resolve([]);
      });
    });
  }


  genParamsAutoComplete() {
    let params = {
      "p": 1,
      "pp": DEFAULT_PER_PAGE_AUTOCOMPLETE,
      "i": Env.DUTY_CAST_EXTENSION_AUTOCOMPLETE_INDEX,
      "l": Search.genLangParams(),
      "t": this.getValue() || ""
    };

    return params;
  }

  isFocus() {
    return this.parent.parent().hasClass("focus") || this.element.hasClass("focus");
  }

  blur() {
    lockScroll(false);
    this.element.removeClass("focus");
    typeof this.onBlur == "function" && this.onBlur();
    setTimeout(() => {
      document.activeElement.blur();
    }, 0);
  }

  focus() {
    $("input", this.element).focus();
  }
}